import { Mapper } from "../../../../core/base";
import { ProductActivityWebEntity } from "./product-activity.web-entity";
import { ProductActivity } from "../../../../core/domain/models";

export class ProductActivityWebRepositoryMapper extends Mapper<ProductActivityWebEntity, ProductActivity> {
  mapFrom(param: ProductActivityWebEntity): ProductActivity {
    return {
      id: param.id,
      name: param.name,
      description: param.description,
      productId: param.productId,
    };
  }

  mapTo(param: ProductActivity): ProductActivityWebEntity {
    return {
      id: param.id,
      name: param.name,
      description: param.description,
      productId: param.productId,
    };
  }
}
